export enum ToolsMenuInfoType {
  SET_INFO_VIEW_STATUS = '@toolsMenuInfo/SET_INFO_VIEW_STATUS',
}

export interface IToolsMenuInfo {
  infoViewed: boolean
}
